import { ReinosMaps } from '../core'
import { reParseLatLngArray } from '../utils'

ReinosMaps.prototype.reParseLatLngArray = function (array) {
  return reParseLatLngArray(array)
}
